import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M9.1 39.7l-1.8-1.8 4.9-4.9 1.8 1.8-4.9 4.9zM39.9 8.9l-1.8-1.8-4.9 4.9 1.8 1.8 4.9-4.9zM11.3 32.1l-1.8-1.8-4.9 4.9L6.4 37l4.9-4.9zM36.4 7l-1.8-1.8-4.9 4.9 1.8 1.8L36.4 7zM16.6 37.5l-1.8-1.8-4.8 4.9 1.8 1.8 4.8-4.9zm25.6-25.6l-1.8-1.8-4.8 4.9 1.8 1.8 4.8-4.9zm-21.7 27l-1.8-1.8-4.5 4.5 1.8 1.8 4.5-4.5zm22.9-22.8l-1.8-1.8-4.5 4.4 1.8 1.8 4.5-4.4zM25.6 39.2l-1.8-1.8-6 5.9 1.8 1.8 6-5.9zm19.5-19.6l-1.8-1.8-6 5.9 1.8 1.8 6-5.9zm.6 4.8l-1.8-1.8-21.2 21.3 1.8 1.8 21.2-21.3zm-1.2 6.4L42.7 29 29 42.8l1.8 1.8 13.7-13.8zM10.1 28l-1.8-1.8-5.1 5.1L5 33.1l5.1-5.1zM33.5 4.6l-1.8-1.8L26.6 8l1.8 1.8 5.1-5.2zM9.6 23.2l-1.8-1.8-6.2 6.2 1.8 1.8 6.2-6.2zM29.4 3.4l-1.8-1.8-6.2 6.2 1.8 1.8 6.2-6.2zm-5-.4l-1.8-1.8-21 21.1 1.8 1.8L24.4 3zm-6.6 1.3L16 2.6l-14 14 1.8 1.8 14-14.1z"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 3.5c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20m0-2.5C11.1 1 1 11.1 1 23.5S11.1 46 23.5 46 46 35.9 46 23.5 35.9 1 23.5 1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 15c4.7 0 8.5 3.8 8.5 8.5S28.2 32 23.5 32 15 28.2 15 23.5s3.8-8.5 8.5-8.5m0-2.5c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 10C30.9 10 37 16 37 23.5S30.9 37 23.5 37 10 30.9 10 23.5 16.1 10 23.5 10m0-2.5c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z"
		})
	] })]
});
export default SvgIcon;
